import script from "./BaseFormField.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFormField.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/baseformfield.scss?vue&type=style&index=0&id=047d4116&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047d4116"]])

export default __exports__